import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Gap } from "../../atoms";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import "../../molecules/ExcoCardView/ExcoFilter.css";
import "../../molecules/ExcoCardView/ExcoCardView.css";
// Import the new Modal
import ModalAddExcoPUK from "../../molecules/ModalAddExcoPUK";
import ExcoCardView from "../../molecules/ExcoCardView";
import AlertMessage from "../../molecules/AlertMessage";
import { getProvince, getKabKot } from "../../../config/Redux/Global/actions";
import {
  getExcoPUK,
  createExcoPUK,
} from "../../../config/Redux/ExcoPusat/actions";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@mui/styles";
import { PRIMARY } from "../../../utils/constansColors";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";

const useStyles = makeStyles({
  root: {
    "& .Mui-selected": {
      backgroundColor: PRIMARY,
      color: "white",
      border: "none",
    },
  },
});

const ExcoPUK = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { dataProvince, dataKabKot } = useSelector((state) => state.global);
  const { dataExcoPUK } = useSelector((state) => state.excopusat);

  const [searchInput, setSearchInput] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [filterProvince, setProvince] = useState("0");
  const [filterCities, setCities] = useState("0");
  const [openModalAdd, setOpenModalAdd] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [loading, setLoading] = useState(false);
  const searchTimeout = useRef(null);

  const provinces = [
    { kode_prov_bps: 0, nama_prov_kemdagri: "Semua Provinsi" },
  ];
  const cities = [
    { kode_kab_kota_bps: 0, nama_kab_kota_kemdagri: "Semua Kab/Kota" },
  ];

  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  let levelExco = profile?.data?.id_tingkat_exco;
  let profileProvince = profile?.data?.id_provinsi;
  let profileKabKot = profile?.data?.id_kabkot;

  if (levelExco === 1) {
    if (dataProvince?.data) {
      for (let i = 0; i < dataProvince.data.length; i++) {
        provinces.push(dataProvince.data[i]);
      }
    }
    if (dataKabKot?.data) {
      for (let i = 0; i < dataKabKot.data.length; i++) {
        cities.push(dataKabKot.data[i]);
      }
    }
  } else if (levelExco === 2) {
    if (dataProvince?.data) {
      for (let i = 0; i < dataProvince.data.length; i++) {
        if (profileProvince === dataProvince.data[i].kode_prov_bps) {
          provinces.push(dataProvince.data[i]);
        }
      }
    }
    if (dataKabKot?.data) {
      for (let i = 0; i < dataKabKot.data.length; i++) {
        cities.push(dataKabKot.data[i]);
      }
    }
  } else if (levelExco === 3) {
    if (dataProvince?.data) {
      for (let i = 0; i < dataProvince.data.length; i++) {
        if (profileProvince === dataProvince.data[i].kode_prov_bps) {
          provinces.push(dataProvince.data[i]);
        }
      }
    }
    if (dataKabKot?.data) {
      for (let i = 0; i < dataKabKot.data.length; i++) {
        if (profileKabKot === dataKabKot.data[i].kode_kab_kota_bps) {
          cities.push(dataKabKot.data[i]);
        }
      }
    }
  }

  useEffect(() => {
    dispatch(getProvince());
  }, [dispatch]);

  // Fetch Data Exco PUK
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const params = {
        page: page,
        limit: limit,
        search: filterSearch,
        id_provinsi: filterProvince !== "0" ? filterProvince : "",
        id_kabkot: filterCities !== "0" ? filterCities : "",
      };
      await dispatch(getExcoPUK(params));
      setLoading(false);
    };
    fetchData();
  }, [dispatch, page, limit, filterSearch, filterProvince, filterCities]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    setPage(1);
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      setFilterSearch(value);
    }, 500);
  };

  const handleSelectProv = async (e) => {
    const val = e.target.value;
    setProvince(val);
    setCities("0");
    setPage(1);

    if (val !== "0") {
      await dispatch(getKabKot(val));
    }
  };

  const handleSelectCities = (e) => {
    setCities(e.target.value);
    setPage(1);
  };

  const [openDialogAlert, setOpenDialogAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(null);

  const handleAddSubmit = async (newData) => {
    // Refresh data after add
    setLoading(true);
    const resp = await dispatch(createExcoPUK(newData));
    if (resp.type === "CREATE_EXCO_PUK_SUCCESS") {
      const params = {
        page: page,
        limit: limit,
        search: filterSearch,
        id_provinsi: filterProvince !== "0" ? filterProvince : "",
        id_kabkot: filterCities !== "0" ? filterCities : "",
      };
      await dispatch(getExcoPUK(params));
      setLoading(false);
      setOpenModalAdd(false);
      setMessage("Berhasil Menambahkan Data");
      setOpenDialogAlert(true);
      setStatus("success");
    } else {
      setLoading(false);
      setMessage(resp.payload?.data?.message || "Gagal Menambahkan Data");
      setOpenDialogAlert(true);
      setStatus("error");
    }
  };

  return (
    <div
      className="exco-puk-container"
      style={{ marginLeft: 20, marginRight: 20 }}
    >
      <Gap height={20} />

      {/* Page Header */}
      <div className="exco-page-header">
        <h1 className="exco-page-title">Komisaris Basis</h1>
      </div>

      <Gap height={20} />

      {/* Single Row Filter */}
      <div className="exco-filter-row">
        {/* Province Filter */}
        <select
          value={filterProvince}
          onChange={handleSelectProv}
          className="exco-filter-dropdown"
          style={{
            maxWidth: "200px",
            minWidth: "150px",
            flex: "0 0 auto",
            boxSizing: "border-box",
            height: "36px",
            padding: "0 26px 0 10px",
            fontSize: "13px",
            backgroundColor: "#fff",
          }}
        >
          {provinces.map((prov, key) => (
            <option key={key} value={prov.kode_prov_bps}>
              {prov.nama_prov_kemdagri}
            </option>
          ))}
        </select>

        {/* Kab/Kota Filter */}
        <select
          value={filterCities}
          onChange={handleSelectCities}
          className="exco-filter-dropdown"
          style={{
            maxWidth: "200px",
            minWidth: "150px",
            flex: "0 0 auto",
            boxSizing: "border-box",
            height: "36px",
            padding: "0 26px 0 10px",
            fontSize: "13px",
            backgroundColor: "#fff",
          }}
        >
          {cities.map((city, key) => (
            <option key={key} value={city.kode_kab_kota_bps}>
              {city.nama_kab_kota_kemdagri}
            </option>
          ))}
        </select>

        {/* Search Input */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: "0 10px",
            flex: "1 1 auto",
            boxSizing: "border-box",
            height: "36px",
          }}
        >
          <SearchIcon style={{ color: "#9CA3AF", marginRight: "8px" }} />
          <input
            type="text"
            placeholder="Search by name"
            value={searchInput}
            onChange={handleSearchChange}
            style={{
              border: "none",
              outline: "none",
              width: "100%",
              fontSize: "13px",
              color: "#1a1a1a",
              background: "transparent",
            }}
          />
        </div>

        {/* Button Tambah Data */}
        <button
          className="exco-btn-add"
          onClick={() => setOpenModalAdd(true)}
          style={{
            height: "36px",
            backgroundColor: "#f06524",
            borderColor: "#f06524",
            color: "#ffffff",
            whiteSpace: "nowrap",
          }}
        >
          <AddIcon className="add-icon" style={{ fontSize: 20 }} />
          Tambah Komisaris Basis
        </button>
      </div>

      <Gap height={20} />

      {/* Card List */}
      <ExcoCardView
        data={dataExcoPUK?.data?.data || []}
        type="puk"
        nameExco="Komisaris Basis"
        loading={loading}
      />

      {/* Pagination */}
      {dataExcoPUK?.data?.data?.length > 0 && (
        <div
          style={{
            justifyContent: "flex-end",
            display: "flex",
            marginTop: "10px",
          }}
        >
          <Pagination
            count={Math.ceil((dataExcoPUK?.data?.total_items || 0) / 10)}
            variant="outlined"
            shape="rounded"
            page={page}
            onChange={handlePageChange}
            className={classes.root}
          />
        </div>
      )}

      {/* Modal Add */}
      <ModalAddExcoPUK
        isOpen={openModalAdd}
        onClose={() => setOpenModalAdd(false)}
        onSubmit={handleAddSubmit}
      />
      <AlertMessage
        openDialog={openDialogAlert}
        message={message}
        status={status}
        handleCloseDialog={() => setOpenDialogAlert(false)}
      />
      <Gap height={100} />
    </div>
  );
};

export default ExcoPUK;
